import { memo, useMemo } from 'react';

import { Plus } from '@air/next-icons';
import { Button, type ButtonProps } from '@air/primitive-button';

export type AddToCanvasButtonProps = Pick<ButtonProps, 'onClick'> & {
  count?: number;
};

export const AddToCanvasButton = memo(({ count, onClick }: AddToCanvasButtonProps) => {
  const label = useMemo(
    () => (count !== undefined && count > 1 ? `Add ${count} to new canvas` : 'Add to new canvas'),
    [count],
  );

  return (
    <Button
      aria-label={label}
      appearance="filled"
      color="blue"
      data-testid="SELECTION_ACTION_BAR_ADD_TO_CANVAS"
      size="small"
      className="ui2:rounded-4"
      prefix={<Plus className="size-4 ui2:size-3" />}
      onClick={onClick}
    >
      {label}
    </Button>
  );
});

AddToCanvasButton.displayName = 'AddToCanvasButton';
